import React from 'react';
import './Footer.css';
import shef from '../assets/shef.png';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer id="contact" className="footer">
      <div className="container">
        {/* Top Section: Brand Only */}
        <div className="footer-main">

          <div className="footer-logo">
              <img width={28} height={38} src={shef} alt="FoodQuick Logo" />
              <span className="logo-text">FoodQuick</span>
            </div>
          <div className="footer-legal-links">
            <a href="https://sites.google.com/view/food-quick/ana-sayfa">{t('footer.privacyPolicy')}</a>
            <a href="https://sites.google.com/view/food-quick/termsofsercice">{t('footer.terms')}</a>
            <a href="mailto:support@foodquick.app">{t('footer.contact')}</a>
            </div>
        </div>

        {/* Bottom Section: Copyright & Simple Links */}
        <div className="footer-bottom">
          <div className="footer-brand">
          <p className="copyright">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
